import { Selector } from 'react-redux';
import { RootState } from '../../redux/root-reducer';
import { IUserConfiguration } from '../../redux/configuration/types';
import { createSelector } from 'reselect';
import { IGetPublishableKeyResponse, IPaymentInitialState } from '../../redux/payment/types';
import { IPaymentCard } from '../../types/global/generic.types';
import { ISubscriptionPlan, ISubscriptionPlanInitialState } from '../../redux/subscription/types';

export const userConfigurationSelector: Selector<RootState, IUserConfiguration> = createSelector(
    (state: RootState) => state.configuration,
    config => config.userSpecificConfiguration,
);

export const appGuideIndex: Selector<RootState, number> = createSelector(
    (state: RootState) => state.configuration,
    config => config.guidedTourIndex,
);

export const paymentStateSelector: Selector<RootState, IPaymentInitialState> = createSelector(
    (state: RootState) => state.payment,
    payment => payment,
);

export const userPaymentMethodsSelector: Selector<RootState, IPaymentCard[] | undefined> = createSelector(
    [paymentStateSelector],
    method => method.paymentMethods,
);

export const userPaymentLoadingSelector: Selector<RootState, boolean> = createSelector(
    [paymentStateSelector],
    method => method.loading ?? false,
);

export const publishableKeySelector: Selector<RootState, IGetPublishableKeyResponse> = createSelector(
    [paymentStateSelector],
    payment => ({
        publishableKey: payment.publishableKey ?? '',
        isNonUs: payment.isNonUs ?? false,
    }),
);

export const subscriptionPlanStateSelector: Selector<RootState, ISubscriptionPlanInitialState> = createSelector(
    (state: RootState) => state.subscription,
    sub => sub,
);

export const plansSelector: Selector<RootState, ISubscriptionPlan[]> = createSelector(
    [subscriptionPlanStateSelector],
    plan => plan.subscriptionPlans,
);

export const userSubscriptionSelector: Selector<RootState, ISubscriptionPlan | undefined> = createSelector(
    [subscriptionPlanStateSelector],
    plan => plan.subscription,
);

export const subscribingSelector: Selector<RootState, boolean> = createSelector(
    [subscriptionPlanStateSelector],
    plan => plan.subscribing,
);
